import { render, staticRenderFns } from "./SettingSKU.vue?vue&type=template&id=6698ceed&scoped=true&"
import script from "./SettingSKU.vue?vue&type=script&lang=js&"
export * from "./SettingSKU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698ceed",
  null
  
)

export default component.exports